export default __webpack_public_path__ + "static/media/DejaVuSansMono.4bb3391b.ttf";